import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SvgContainer = styled.span`
  display: inline-flex;
  align-items: center;
`

const Svg = styled.svg`
  width: 3rem;
  height: 3rem;
  position: relative;
  top: ${props => props.baseline ? '-1.1rem' : '0'};
`

export const Cross = (props) => (
  <SvgContainer>
    <Svg width={20} height={20} viewBox="0 0 20 20" {...props}>
      <path
        d="M5.5 5.5l9 9m0-9l-9 9"
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth={1.5}
      />
    </Svg>
  </SvgContainer>
)

Cross.propTypes = {
  baseline: PropTypes.bool
}
